import { Component, OnInit, Input } from '@angular/core'
import { ValidatedRadioButtonModel } from '../../../../../validations/validated-radio-button-group.component'
import { Router } from '@angular/router'
import { EnrollmentViewModel } from '../../../../models/enrollment-view-model'
import { EnrollmentGateway } from '../../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../../portalglobals'
import * as moment from 'moment'
import { CurrentUserGateway } from '../../../../../common/gateways/current-user-gateway'
import { EnrollmentCacheData } from '../../../../models/EnrollmentCacheData'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../../../models/get-enrollment-data-response'
@Component({
    selector: 'PhoneEnrollmentSpanishStep5',
    templateUrl: 'phone-enrollment-step5.component.html',
    styleUrls: ['../phone-enrollment.component.scss']
})
export class PhoneEnrollmentSpanishStep5Component implements OnInit {
    public rblAgreement: ValidatedRadioButtonModel[] = []
    public rblValidInfo: ValidatedRadioButtonModel[] = []
    public rblTerm: ValidatedRadioButtonModel[] = []
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    public IsRblAgreementNo: boolean
    public IsRblAgreementYes: boolean
    public IsRblValidInfoNo: boolean
    public IsRblValidInfoYes: boolean
    public CurrentDate: string
    public BenefName: string
    public agentName: string
    isQtip: boolean
    planName: string
    insuranceComapny: string
    spnIsBeneficiary: string
    spnhimher: string
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    ShowCurrentYearScript: boolean = false
    public IsRblTermYes: boolean
    public IsRblTermNo: boolean

    constructor(
        private _enrollementGateway: EnrollmentGateway,
        public _global: PortalGlobals,
        private router: Router,
        private _currentUserGateway: CurrentUserGateway
    ) {
        this.rblAgreement.push({ value: 'Yes', htmlLabel: 'Si' }, { value: 'No', htmlLabel: 'No' })
        this.rblValidInfo.push({ value: 'True', htmlLabel: 'True' }, { value: 'False', htmlLabel: 'False' })
        this.rblTerm.push({ value: 'Yes', htmlLabel: 'Si' }, { value: 'No', htmlLabel: 'No' })
        this.IsRblAgreementYes = false
        this.IsRblAgreementNo = false
        this.IsRblValidInfoYes = false
        this.IsRblValidInfoNo = false
        this.isQtip = false
        this.IsRblTermYes = false
        this.IsRblTermNo = false

        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true
        } else {
            this.ShowCurrentYearScript = false
        }
    }

    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)
        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate([
                '/' +
                    insCo +
                    '/enrollment/phone-enrollment/spanish/Step1/' +
                    this.enrollmentCacheData.CALLOGID +
                    '/' +
                    this.enrollmentCacheData.PlanYear
            ])
        }
        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                        this.enrollmentViewModel.CALLOGID = this.enrollmentCacheData.CALLOGID

                        this.LoadData()
                    },
                    (err) => {}
                )
            } else {
                this.router.navigate([
                    '/' +
                        insCo +
                        '/enrollment/phone-enrollment/spanish/Step1/' +
                        this.enrollmentViewModel.CALLOGID +
                        '/' +
                        this.enrollmentViewModel.PLANYEAR
                ])
            }
        } else {
            this.LoadData()
        }
    }

    SalesBenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/BeneficiaryDetails/6'])
    }

    LoadData(): void {
        if (this._global === undefined || this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    this.insuranceComapny = this._global.currentUser.insuranceCompanyName
                }
            })
        }
        if (this._global.currentUser !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.BenefName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
        this.agentName = this._global.currentUser.firstName
        this.planName = this.enrollmentViewModel.PLANTYPENAME
        this.setScript()
        this.CurrentDate = moment().format('MM/DD/YYYY')
        if (
            this.enrollmentViewModel.CALLOGID !== null &&
            this.enrollmentViewModel.CALLOGID !== undefined &&
            this.enrollmentViewModel.CALLOGID !== 0
        ) {
            this.isQtip = true
        }
        this.ShowOptionsRblAgreement(this.enrollmentViewModel.RBLAGREEMENT)
        // this.ShowOptionsRblValidInfo(this.enrollmentViewModel.RBLVALIDINFO)
        this.ShowOptionsRblTerm(this.enrollmentViewModel.RBLVALIDINFO)
    }
    ShowOptionsRblTerm(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsRblTermYes = true
            this.IsRblTermNo = false
            //this.IsRblValidInfoYes = true
        }
        if (isgroup === 'No') {
            this.IsRblTermYes = false
            this.IsRblTermNo = true
            this.enrollmentViewModel.RBLAGREEMENT = ''
            this.IsRblAgreementNo = false
            this.IsRblValidInfoYes = false
        }
        this.enrollmentViewModel.RBLVALIDINFO = isgroup
    }
    ShowOptionsRblAgreement(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsRblAgreementYes = true
            this.IsRblAgreementNo = false
            this.IsRblValidInfoYes = true
        }
        if (isgroup === 'No') {
            this.IsRblAgreementYes = false
            this.IsRblAgreementNo = true
            this.IsRblValidInfoYes = false
        }
        this.enrollmentViewModel.RBLAGREEMENT = isgroup

        //if (this.ShowCurrentYearScript)
        //{
        //    if (isgroup === 'Yes')
        //    {
        //    this.IsRblValidInfoYes = true
        //    this.IsRblValidInfoNo = false

        // }
        //    if (isgroup === 'No') {
        //    this.IsRblValidInfoYes = false
        //    this.IsRblValidInfoNo = true
        //}
        //this.enrollmentViewModel.RBLVALIDINFO = isgroup
        //  }
    }

    ShowOptionsRblValidInfo(isgroup: string) {
        if (isgroup === 'True') {
            this.IsRblValidInfoYes = true
            this.IsRblValidInfoNo = false
        }
        if (isgroup === 'False') {
            this.IsRblValidInfoYes = false
            this.IsRblValidInfoNo = true
        }
        this.enrollmentViewModel.RBLVALIDINFO = isgroup
    }
    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/Step4'])
    }
    formSubmit(): void {
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '5'
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/spanish/Preview'])
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    setScript() {
        this.spnhimher = '(him, her)'
        if (this.enrollmentViewModel.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'usted'
        }
        if (this.enrollmentViewModel.RBLBENFE === 'No' && this.BenefName !== ' ' && this.BenefName !== 'undefined undefined') {
            this.spnIsBeneficiary = this.BenefName
        }
        if (this.enrollmentViewModel.RBLBENFE === 'No' && (this.BenefName === ' ' || this.BenefName === 'undefined undefined')) {
            this.spnIsBeneficiary = '(usted, nombre de la persona inscripta)'
        }
        if (this.enrollmentViewModel.APPGEN === 'F') {
            this.spnhimher = 'her'
        }
        if (this.enrollmentViewModel.APPGEN === 'M') {
            this.spnhimher = 'him'
        }
    }
}
